import React from 'react';
import FIELD_NAME from './const';
import InputField from './Input';
import NumberWithTemplate from './NumberWithTemplate';
import Checkbox from './Checkbox';
import PasswordWithMeter from './PasswordWithMeter';

function inputElement(model) {
  const elementProps = {
    ...model.props,
    key: model.key,
  };
  return <input { ...elementProps } />;
}

function inputField(model) {
  const fieldProps = {
    ...model.props,
    key: model.key,
  };
  return <InputField { ...fieldProps } />;
}

function numberWithTemplateField(model) {
  const fieldProps = {
    ...model.props,
    key: model.key,
  };
  return <NumberWithTemplate { ...fieldProps } />;
}

function checkboxField(model) {
  const fieldProps = {
    ...model.props,
    key: model.key,
  };
  return <Checkbox { ...fieldProps } />;
}

function passwordWithMeterField(model) {
  const fieldProps = {
    ...model.props,
    key: model.key,
  };
  return <PasswordWithMeter { ...fieldProps } />;
}

export default {
  create: {
    [FIELD_NAME.FIELD.INPUT]: inputField,
    [FIELD_NAME.FIELD.NUMBER_WITH_TEMPLATE]: numberWithTemplateField,
    [FIELD_NAME.FIELD.CHECKBOX]: checkboxField,
    [FIELD_NAME.FIELD.PASSWORD_WITH_METER]: passwordWithMeterField,
    [FIELD_NAME.ELEMENT.INPUT]: inputElement,
  },
};
